const HistorySchema = {
    carrier: null,
    policyNumber: null,
    policyStatus: null,
    policyType: null,
    compOnlyPolicy: "N",
    policyReportedDate: null,
    inceptionDate: null,
    lastReportedTermEffectiveDate: null,
    lastReportedTermExpirationDate: null,
    numberOfCancellations: null,
    numberOfRenewals: null,
    hasPossibleLapse: null,
    isCurrentInforceCoverage: null,
    numberOfCoverageDays: null,
    hasBreakFromPriorCoverage: null,
    numberOfLapseDays: null,
    coverages: [
      {
        coverageType: {
          code: "MPAY",
          description: "Medical Payments"
        },
        individualLimitAmount: '',
        occurrenceLimitAmount: '',
        combinedSingleLimitAmount: '',
        fromDate: null,
        toDate: null,
      },
      {
        coverageType: {
          code: "PINJ",
          description: "Personal Injury"
        },
        individualLimitAmount: '',
        occurrenceLimitAmount: '',
        combinedSingleLimitAmount:'',
        fromDate: null,
        toDate: null,
      },
      {
        coverageType: {
          code: "BINJ",
          description: "Bodily Injury"
        },
        individualLimitAmount: '',
        occurrenceLimitAmount: '',
        combinedSingleLimitAmount:'',
        fromDate: null,
        toDate: null,
      }
    ],
    policyHolders: [
      {
        givenName: null,
        middleName: null,
        surname: null,
        nameSuffix: null,
        dob: null,
        dlNumber: null,
        dlState: null,
      }
    ],
    addresses: [
      {
        addressType:null,
        street1: null,
        city: null,
        stateCode: null,
        zip: null,
        fromDate: null,
        toDate:  null,
      }
    ],
    city:  null,
    stateCode: null,
    street1:  null,
    zip:  null,
    addressType:  null,
    policyHolder:  null,
  };

  export default HistorySchema;


// WEBPACK FOOTER //
// ./src/History/store.js